<script lang="ts">
    import { Button, Icon, Popover, f7 } from 'framework7-svelte';
    export let label: string;

    let popoverId: string = Math.round(Math.random() * 1_000_000).toString();
    let popoverComponent: Popover;
    let hoverPopoverComponent: Popover;
    let isOpen: boolean = false;

    export let activeIcon: string = '';
    export let activeIconClass: string = '';
    export let inactiveIcon: string = '';
    export let inactiveIconClass: string = '';
    export let active: boolean = false;
    export let popoverHeight: string = '';
    export let popoverWidth: string = '';
    export let hoverControlHeight: string = '';
    export let hoverControlWidth: string = '';
    export let disabled: boolean = false;

    /*
     * This is used because the popover doesn't close properly when another button is clicked while it is open.
     */
    function openPopover(e: Event) {
        if (disabled) {
            return;
        }
        const el = e.currentTarget as HTMLElement;
        const rect = el.getBoundingClientRect();
        const popupElement = document.querySelector(`#popover-${popoverId}`);

        if (isOpen) {
            popoverComponent.instance().close();
            isOpen = false;
            return;
        }
        isOpen = true;
        popoverComponent.instance().open({
            targetEl: e.target
        });
        popupElement.style.left = rect.left + 'px';
        popupElement.style.top = rect.top + rect.height + 'px';
    }

    function openHoverControl(e) {
        if (isOpen || disabled) {
            return;
        }
        const el = e.currentTarget as HTMLElement;
        const rect = el.getBoundingClientRect();
        const popupElement = document.querySelector(`#hover-popover-${popoverId}`);
        hoverPopoverComponent.instance().open({
            targetEl: e.target
        });
        popupElement.style.left = rect.left + 'px';
        popupElement.style.top = rect.top + rect.height + 'px';
    }

    function closeHoverControl() {
        hoverPopoverComponent.instance().close();
    }
</script>

<div on:mouseenter={openHoverControl} on:mouseleave={closeHoverControl}>
    <div on:click={openPopover} on:keydown={openPopover} role="button" tabindex="0">
        <Button class="fb custom-hover {active ? 'fb--active' : ''}" raised>
            {#if active && activeIcon}
                <Icon material={activeIcon} class={activeIconClass} size="18px" />
            {/if}
            {#if !active && inactiveIcon}
                <Icon material={inactiveIcon} class={inactiveIconClass} size="18px" />
            {/if}
            {label}
            <Icon material="arrow_drop_down" size="18px" />
        </Button>
    </div>
</div>

<Popover
    id={`popover-${popoverId}`}
    style="position: fixed; {popoverHeight ? `height: ${popoverHeight};` : ''} {popoverWidth ? `width: ${popoverWidth};` : ''}"
    class="fb__popover"
    arrow={false}
    backdrop={false}
    closeByOutsideClick={true}
    bind:this={popoverComponent}
    onPopoverClosed={() => (isOpen = false)}
>
    <slot />
</Popover>
<Popover
    id={`hover-popover-${popoverId}`}
    class="fb__popover"
    style="{hoverControlHeight ? `height: ${hoverControlHeight};` : ''} {hoverControlWidth ? `width: ${hoverControlWidth};` : ''}"
    arrow={false}
    backdrop={false}
    closeByOutsideClick={true}
    animate={false}
    bind:this={hoverPopoverComponent}
>
    <slot name="hover-control" />
</Popover>

<style>
    :global(.fb.fb--active) {
        background-color: var(--fab-active-bg-color);
        color: var(--fab-active-color);
    }

    :global(.fb.fb--active:hover) {
        filter: brightness(90%);
        background-color: var(--fab-active-bg-color);
    }

    :global(.fb) {
        padding: 0px 16px;
        background-color: var(--fab-bg-color);
        color: var(--fab-color);
    }
    :global(.fb:hover) {
        filter: brightness(90%);
    }

    :global(.fb-dummy) {
        width: 0px;
    }
    :global(.fb__popover) {
        margin-top: 8px;
        box-shadow: 1px 1px 3px #0000004d;
    }
    :global(.fb__popover) {
        transform: translateY(var(--f7-popover-transform-y, 0)) !important;
    }
    :global(.fb.button) {
        height: 32px;
    }
</style>
